module.exports = __webpack_public_path__ + "static/img/BH.fa1aaf6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/BH.svg
// module id = /fc8
// module chunks = 66